export default __webpack_public_path__ + "static/media/CSSCircularBackground-light-sepia-350px.31dc692f.jpg";